 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"runtime": 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"default~modules-academic-academic-module~modules-attendance-attendance-module~modules-chat-chat-modu~1dddacfe":"default~modules-academic-academic-module~modules-attendance-attendance-module~modules-chat-chat-modu~1dddacfe","default~modules-academic-academic-module~modules-admission-admission-module~modules-attendance-atten~4150e1ec":"default~modules-academic-academic-module~modules-admission-admission-module~modules-attendance-atten~4150e1ec","default~modules-academic-academic-module~modules-activities-activities-module~modules-attendance-att~01d8931c":"default~modules-academic-academic-module~modules-activities-activities-module~modules-attendance-att~01d8931c","default~modules-admission-admission-module~modules-external-external-module~modules-notification-set~0c26cf7a":"default~modules-admission-admission-module~modules-external-external-module~modules-notification-set~0c26cf7a","default~modules-auth-auth-module~modules-external-external-module~pages-layout-module":"default~modules-auth-auth-module~modules-external-external-module~pages-layout-module","default~modules-academic-academic-module~modules-attendance-attendance-module~modules-external-exter~e75d62e4":"default~modules-academic-academic-module~modules-attendance-attendance-module~modules-external-exter~e75d62e4","default~modules-external-external-module~pages-layout-module":"default~modules-external-external-module~pages-layout-module","modules-external-external-module":"modules-external-external-module","modules-auth-auth-module":"modules-auth-auth-module","default~modules-mail-mail-module~modules-other-other-module~quill":"default~modules-mail-mail-module~modules-other-other-module~quill","common":"common","modules-payroll-payroll-module":"modules-payroll-payroll-module","default~dashboard-dashboard-module~modules-other-other-module~modules-user-profile-user-profile-modu~d4a1b76a":"default~dashboard-dashboard-module~modules-other-other-module~modules-user-profile-user-profile-modu~d4a1b76a","default~dashboard-dashboard-module~modules-user-profile-user-profile-module~view-profile-view-profile-module":"default~dashboard-dashboard-module~modules-user-profile-user-profile-module~view-profile-view-profile-module","modules-user-profile-user-profile-module":"modules-user-profile-user-profile-module","dashboard-dashboard-module":"dashboard-dashboard-module","default~modules-academic-academic-module~modules-activities-activities-module~modules-admission-admi~21cc718f":"default~modules-academic-academic-module~modules-activities-activities-module~modules-admission-admi~21cc718f","modules-library-library-module":"modules-library-library-module","default~modules-academic-academic-module~modules-activities-activities-module~modules-attendance-att~375a8591":"default~modules-academic-academic-module~modules-activities-activities-module~modules-attendance-att~375a8591","modules-activities-activities-module":"modules-activities-activities-module","modules-admission-admission-module":"modules-admission-admission-module","default~modules-mail-mail-module~modules-other-other-module":"default~modules-mail-mail-module~modules-other-other-module","modules-other-other-module":"modules-other-other-module","default~modules-academic-academic-module~modules-attendance-attendance-module~modules-users-users-module":"default~modules-academic-academic-module~modules-attendance-attendance-module~modules-users-users-module","default~modules-fee-fee-module~modules-users-users-module":"default~modules-fee-fee-module~modules-users-users-module","modules-users-users-module":"modules-users-users-module","default~modules-academic-academic-module~modules-attendance-attendance-module~modules-chat-chat-modu~745a3ef5":"default~modules-academic-academic-module~modules-attendance-attendance-module~modules-chat-chat-modu~745a3ef5","modules-chat-chat-module":"modules-chat-chat-module","modules-communication-communication-module":"modules-communication-communication-module","default~modules-academic-academic-module~modules-attendance-attendance-module~modules-reports-Academ~0b44fd25":"default~modules-academic-academic-module~modules-attendance-attendance-module~modules-reports-Academ~0b44fd25","default~modules-academic-academic-module~modules-attendance-attendance-module~modules-reports-Academ~1b36d50f":"default~modules-academic-academic-module~modules-attendance-attendance-module~modules-reports-Academ~1b36d50f","default~modules-academic-academic-module~modules-attendance-attendance-module":"default~modules-academic-academic-module~modules-attendance-attendance-module","modules-attendance-attendance-module":"modules-attendance-attendance-module","modules-reports-AcademicReports-module":"modules-reports-AcademicReports-module","modules-ssp-ssp-module":"modules-ssp-ssp-module","modules-fee-fee-module":"modules-fee-fee-module","modules-gallery-gallery-module":"modules-gallery-gallery-module","modules-notification-setting-notification-setting-module":"modules-notification-setting-notification-setting-module","modules-task-management-task-management-module":"modules-task-management-task-management-module","modules-transactions-transaction-module":"modules-transactions-transaction-module","modules-transportation-transportation-module":"modules-transportation-transportation-module","modules-inventory-management-inventory-management-module":"modules-inventory-management-inventory-management-module","modules-support-ticket-support-ticket-module":"modules-support-ticket-support-ticket-module","modules-permission-set-permission-set-module":"modules-permission-set-permission-set-module","modules-mail-mail-module":"modules-mail-mail-module","modules-acadmic-year-config-acadmic-year-module":"modules-acadmic-year-config-acadmic-year-module","modules-calendar-calendar-module":"modules-calendar-calendar-module","modules-errors-errors-module":"modules-errors-errors-module","modules-gateway-gateway-module":"modules-gateway-gateway-module","modules-setting-setting-module":"modules-setting-setting-module","view-profile-view-profile-module":"view-profile-view-profile-module","canvg":"canvg","dompurify":"dompurify"}[chunkId]||chunkId) + "-es2015.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"modules-calendar-calendar-module":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"default~modules-academic-academic-module~modules-attendance-attendance-module~modules-chat-chat-modu~1dddacfe":"default~modules-academic-academic-module~modules-attendance-attendance-module~modules-chat-chat-modu~1dddacfe","default~modules-academic-academic-module~modules-admission-admission-module~modules-attendance-atten~4150e1ec":"default~modules-academic-academic-module~modules-admission-admission-module~modules-attendance-atten~4150e1ec","default~modules-academic-academic-module~modules-activities-activities-module~modules-attendance-att~01d8931c":"default~modules-academic-academic-module~modules-activities-activities-module~modules-attendance-att~01d8931c","default~modules-admission-admission-module~modules-external-external-module~modules-notification-set~0c26cf7a":"default~modules-admission-admission-module~modules-external-external-module~modules-notification-set~0c26cf7a","default~modules-auth-auth-module~modules-external-external-module~pages-layout-module":"default~modules-auth-auth-module~modules-external-external-module~pages-layout-module","default~modules-academic-academic-module~modules-attendance-attendance-module~modules-external-exter~e75d62e4":"default~modules-academic-academic-module~modules-attendance-attendance-module~modules-external-exter~e75d62e4","default~modules-external-external-module~pages-layout-module":"default~modules-external-external-module~pages-layout-module","modules-external-external-module":"modules-external-external-module","modules-auth-auth-module":"modules-auth-auth-module","default~modules-mail-mail-module~modules-other-other-module~quill":"default~modules-mail-mail-module~modules-other-other-module~quill","common":"common","modules-payroll-payroll-module":"modules-payroll-payroll-module","default~dashboard-dashboard-module~modules-other-other-module~modules-user-profile-user-profile-modu~d4a1b76a":"default~dashboard-dashboard-module~modules-other-other-module~modules-user-profile-user-profile-modu~d4a1b76a","default~dashboard-dashboard-module~modules-user-profile-user-profile-module~view-profile-view-profile-module":"default~dashboard-dashboard-module~modules-user-profile-user-profile-module~view-profile-view-profile-module","modules-user-profile-user-profile-module":"modules-user-profile-user-profile-module","dashboard-dashboard-module":"dashboard-dashboard-module","default~modules-academic-academic-module~modules-activities-activities-module~modules-admission-admi~21cc718f":"default~modules-academic-academic-module~modules-activities-activities-module~modules-admission-admi~21cc718f","modules-library-library-module":"modules-library-library-module","default~modules-academic-academic-module~modules-activities-activities-module~modules-attendance-att~375a8591":"default~modules-academic-academic-module~modules-activities-activities-module~modules-attendance-att~375a8591","modules-activities-activities-module":"modules-activities-activities-module","modules-admission-admission-module":"modules-admission-admission-module","default~modules-mail-mail-module~modules-other-other-module":"default~modules-mail-mail-module~modules-other-other-module","modules-other-other-module":"modules-other-other-module","default~modules-academic-academic-module~modules-attendance-attendance-module~modules-users-users-module":"default~modules-academic-academic-module~modules-attendance-attendance-module~modules-users-users-module","default~modules-fee-fee-module~modules-users-users-module":"default~modules-fee-fee-module~modules-users-users-module","modules-users-users-module":"modules-users-users-module","default~modules-academic-academic-module~modules-attendance-attendance-module~modules-chat-chat-modu~745a3ef5":"default~modules-academic-academic-module~modules-attendance-attendance-module~modules-chat-chat-modu~745a3ef5","modules-chat-chat-module":"modules-chat-chat-module","modules-communication-communication-module":"modules-communication-communication-module","default~modules-academic-academic-module~modules-attendance-attendance-module~modules-reports-Academ~0b44fd25":"default~modules-academic-academic-module~modules-attendance-attendance-module~modules-reports-Academ~0b44fd25","default~modules-academic-academic-module~modules-attendance-attendance-module~modules-reports-Academ~1b36d50f":"default~modules-academic-academic-module~modules-attendance-attendance-module~modules-reports-Academ~1b36d50f","default~modules-academic-academic-module~modules-attendance-attendance-module":"default~modules-academic-academic-module~modules-attendance-attendance-module","modules-attendance-attendance-module":"modules-attendance-attendance-module","modules-reports-AcademicReports-module":"modules-reports-AcademicReports-module","modules-ssp-ssp-module":"modules-ssp-ssp-module","modules-fee-fee-module":"modules-fee-fee-module","modules-gallery-gallery-module":"modules-gallery-gallery-module","modules-notification-setting-notification-setting-module":"modules-notification-setting-notification-setting-module","modules-task-management-task-management-module":"modules-task-management-task-management-module","modules-transactions-transaction-module":"modules-transactions-transaction-module","modules-transportation-transportation-module":"modules-transportation-transportation-module","modules-inventory-management-inventory-management-module":"modules-inventory-management-inventory-management-module","modules-support-ticket-support-ticket-module":"modules-support-ticket-support-ticket-module","modules-permission-set-permission-set-module":"modules-permission-set-permission-set-module","modules-mail-mail-module":"modules-mail-mail-module","modules-acadmic-year-config-acadmic-year-module":"modules-acadmic-year-config-acadmic-year-module","modules-calendar-calendar-module":"modules-calendar-calendar-module","modules-errors-errors-module":"modules-errors-errors-module","modules-gateway-gateway-module":"modules-gateway-gateway-module","modules-setting-setting-module":"modules-setting-setting-module","view-profile-view-profile-module":"view-profile-view-profile-module","canvg":"canvg","dompurify":"dompurify"}[chunkId]||chunkId) + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");

 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				var onLinkComplete = function (event) {
 					// avoid mem leaks.
 					linkTag.onerror = linkTag.onload = null;
 					if (event.type === 'load') {
 						resolve();
 					} else {
 						var request = event && event.target && event.target.href || fullhref;
 						var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 						err.code = "CSS_CHUNK_LOAD_FAILED";
 						err.request = request;
 						delete installedCssChunks[chunkId]
 						linkTag.parentNode.removeChild(linkTag)
 						reject(err);
 					}
 				};
 				linkTag.onerror = linkTag.onload = onLinkComplete;
 				linkTag.href = fullhref;

 				document.head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
